module.exports = __webpack_public_path__ + "img/logo_gg.bab252d0.png";